import { render, staticRenderFns } from "./LiquidityAdd.vue?vue&type=template&id=5e969880&"
import script from "./LiquidityAdd.vue?vue&type=script&lang=js&"
export * from "./LiquidityAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports